import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Modal from "app/modules/common/component/Modal";
import * as c from "../constant";

class ContactRecruitmentModal extends PureComponent {
  state = {
    message: "",
    contact: "",
  };

  handleOnClose = (e) => {
    e.preventDefault();
    const { dispatch } = this.props;
    dispatch({
      type: "MODAL",
      data: {
        isOpen: false,
      },
    });
  };

  handleOnChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleOnSubmit = (e) => {
    e.preventDefault();
    const { dispatch, data } = this.props;
    const args = {
      name: `${data.firstname}, ${data.middlename}, ${data.lastname}`,
      contact: this.state.contact,
      birthdate: data.birthdate,
      message: this.state.message,
    };
    dispatch({
      type: c.CONTACT_RECRUITMENT,
      args,
    });
  };

  render() {
    const { data } = this.props;

    return (
      <div>
        <form>
          <Modal.Body>
            <form class="label-top" onSubmit={this.handleOnSubmit}>
              <div className="modal-body job-info">
                <div className="">
                  <p>
                    The information you entered already exists in our records.
                    Please fill out the form and click submit.
                  </p>
                </div>
              </div>
              <div className="input-group mb-3 jobs-search-wrap flex-sm-column flex-md-row">
                <label className="col-sm-12 font-weight-bold  col-form-label">
                  Contact Number
                </label>
                <div className="col-sm-12 col-md-12">
                  <input
                    type="text"
                    name="contact"
                    className="form-control"
                    value={this.state.contact}
                    onChange={this.handleOnChange}
                    required
                  />
                </div>
              </div>
              <div className="input-group mb-3 jobs-search-wrap flex-sm-column flex-md-row">
                <label className="col-sm-12 font-weight-bold col-form-label">
                  Message
                </label>
                <div className="col-sm-12 col-md-12">
                  <textarea
                    type="text"
                    name="message"
                    rows="5"
                    className="form-control"
                    value={this.state.message}
                    onChange={this.handleOnChange}
                    required
                  />
                </div>
              </div>
              <div className="input-group mb-3 jobs-search-wrap flex-sm-column flex-md-row ">
                <label className="col-sm-12 font-weight-bold col-form-label"></label>
                <div className="col-sm-12 col-md-12">
                  <button
                    className="btn btn-block btn-lg btn-primary"
                    disabled={this.props.isLoading}
                  >
                    {this.props.isLoading ? "Sending" : "Submit"}
                  </button>
                </div>
              </div>
            </form>
          </Modal.Body>
        </form>
      </div>
    );
  }
}

const mapPropsToState = (state, props) => {
  const { loadingTypes } = state.loading;

  return {
    isLoading: loadingTypes.length > 0,
  };
};

export default withRouter(connect(mapPropsToState)(ContactRecruitmentModal));
